import autoTable from "jspdf-autotable";

import { format } from "crypto-js";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

  function format(value) {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }



  const columnStyles = {
    0: { cellWidth: 80, halign: "center" },
    1: { cellWidth: 65, halign: "right" },
    2: { cellWidth: 45, halign: "right" },
    

  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

   // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
...PDF_TABLE_STYLE,
    head: [[

      "ATD NO",
      "Dr Amount",
      "Cr Amount",
      

    ]],


    body: rows.map((r) => [
      (r.Description),
      format(r.DEBIT),
      format(r.CREDIT),

    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 190, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`TOTAL`, 50, y + 5);

  // Debit Total
  doc.text(format(total.debit), 155, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.credit), 200, y + 5, {
    align: "right",
  });

  
  // Reset text color
 
//  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL);
//   doc.rect(55, y+15, 120, 8, "F");

// doc.text(`Net Amount (Dr -Cr)`, 70, y + 20);

//   // Debit Total
//   doc.text(format(Number(total.debit)-Number(total.credit)), 140, y + 20, {
//     align: "right",
//   });
//  doc.setTextColor(0);
//   // Reserve space after Depot Total
//   doc.lastAutoTable.finalY = y + 5;
//   //                 rectangle height ^   ^ extra space
}



